import { useEffect, useMemo } from 'react';
import { UseInfiniteQueryResult } from 'react-query';

export default function usePrefetchPages<
  TData,
  TQuery extends UseInfiniteQueryResult,
  TPage = TQuery extends UseInfiniteQueryResult<infer R> ? R : unknown
>(query: TQuery, flatMap?: (data: TPage) => TData[], max?: number) {
  useEffect(() => {
    if (query.hasNextPage && (query.data?.pages?.length ?? 0) < (max ?? Infinity)) {
      query.fetchNextPage();
    }
  }, [max, query]);

  return useMemo(() => {
    if (flatMap && query.data) {
      return (query.data.pages as TPage[]).flatMap(flatMap);
    }
    return [];
  }, [flatMap, query.data]);
}
